<div class="signup">
    <div class="signup-header">
        <div class="signup-header-title">Sign Up Status</div>
        @if (!model.draft) {
            <fhm-action-buttons class="signup-header-actions">
                <fui-commands [title]="'fhm.common.button.actions'" [showPopupForSingleItems]="true">
                    @if (model.contractComplete) {
                        <fui-command [title]="'Download Contract'"
                                     (clicked$)="downloadContract()"></fui-command>
                    }
                    @if (this.model.data.venue.deploymentStatus !== CustomerInstanceVenueData.DEPLOYMENT_STATUS_CHURNED) {
                        @if (!model.signUpComplete && model.data.venue.salesRep && !UserData.isSalesManager(loggedUser)) {
                            <fui-command [title]="'Sign in Person'"
                                         (clicked$)="signInPerson()"></fui-command>
                        }
                        @if (!model.signUpComplete && model.data.venue.salesRep) {
                            <fui-command [title]="'Email Contract'"
                                         (clicked$)="sendSignUpUrl()"></fui-command>
                        }
                        @if (model.contractComplete && !model.signUpComplete && !UserData.isSalesManager(loggedUser)) {
                            <fui-command [title]="'Get Sign Up URL'"
                                         (clicked$)="getSignUpUrl()"></fui-command>
                        }
                        @if (!UserData.isSalesManager(loggedUser)) {
                            <fui-command [title]="'Upload Contract'"
                                         (clicked$)="uploadContract()"></fui-command>
                        }
                        @if (customContract && (!model.data.contract.signedContract || !model.data.contract.signedContract.directorSigned)) {
                            <fui-command [title]="'View as Director'"
                                         (clicked$)="viewDocAsDirector()"></fui-command>
                        }
                        @if (!model.draft && !model.signUpComplete && model.data.venue.salesRep && !UserData.isSalesManager(loggedUser)) {
                            <fui-command [title]="'Unlock Form'"
                                         (clicked$)="resetContract()"></fui-command>
                        }
                        @if (showMarkAsReady) {
                            <fui-command [title]="'Mark as Ready'"
                                         (clicked$)="markAsReady()"></fui-command>
                        }
                        @if (showOpenCustomerStripe) {
                            <fui-command [title]="'Open Stripe'"
                                         (clicked$)="openCustomerStripe()"></fui-command>
                        }
                        @if (!UserData.isSalesManager(loggedUser) && !UserData.isSalesRep(loggedUser) && model.contractComplete) {
                            <fui-command [title]="'Change Direct Debit'"
                                         (clicked$)="openCustomerPortal()"></fui-command>
                        }
                        @if (!UserData.isSalesManager(loggedUser) && !model.data.hasSales && model.contractComplete && !model.appPaymentAccountVerified && !tyro) {
                            <fui-command [title]="'Setup Payment Account (Stripe) in Person'"
                                         (clicked$)="openAppPaymentAccountSetup()"></fui-command>
                        }
                        @if (!UserData.isSalesManager(loggedUser) && !model.data.hasSales && model.contractComplete && !model.appPaymentAccountVerified && !tyro) {
                            <fui-command [title]="'Get Setup Payment Account (Stripe) URL'"
                                         (clicked$)="getSetupAppPaymentAccountUrl()"></fui-command>
                        }
                        @if (!UserData.isSalesManager(loggedUser) && !model.data.venue.discontinued && UserData.isAdmin(loggedUser)) {
                            <fui-command [title]="'Discontinue'"
                                         (clicked$)="discontinue()"></fui-command>
                        }
                        @if (!UserData.isSalesManager(loggedUser) && model.data.venue.discontinued && UserData.isAdmin(loggedUser)) {
                            <fui-command [title]="'Recontinue'"
                                         (clicked$)="recontinue()"></fui-command>
                        }
                    }
                </fui-commands>
            </fhm-action-buttons>
        }
        <input #inputUploadFile class="input-upload-file" type="file" [attr.accept]="validContractFileTypes"
               (click)="inputUploadContractClick($event)"
               (change)="fileSelected($event)">
    </div>
    @if (this.model.data.venue.deploymentStatus !== CustomerInstanceVenueData.DEPLOYMENT_STATUS_CHURNED) {
        <div class="signup-body">

            @if (!model.signUpComplete && model.draft) {
                <div class="signup-body-message">
                    Customer sign up is <b>draft</b>. Complete the details below and click <b>Sign Up</b> to submit to the
                    customer.
                </div>
            }
            @if (!model.signUpComplete && !model.draft) {
                <div class="signup-body-message">
                    Waiting for the customer to sign the Customer Agreement and provide Direct Debit details.
                </div>
            }
            @if (model.signUpComplete) {
                <div class="signup-body-message">
                    Customer sign up is complete.
                </div>
            }
            @if (!model.draft) {
                <div class="signup-body-status">
                    @if (signUpSent && (!(model.data.contract && model.data.contract.signedContract && model.data.contract.signedContract.customerSigned) || !model.billingComplete)) {
                        <div
                            class="signup-body-status-item">
                            <div class="signup-body-status-item-tick" [ngClass]="{'complete': signUpSent}">
                            </div>
                            @if (signUpSent) {
                                <div class="signup-body-status-item-name">
                                    Email sign up form to the customer ({{ model.data.venue.signUpUrlSentDate }})
                                </div>
                            }
                        </div>
                    }
                    <div class="signup-body-status-item">
                        <div class="signup-body-status-item-tick"
                             [ngClass]="{'complete': (model.data.contract && model.data.contract.signedContract && model.data.contract.signedContract.customerSigned)}">
                        </div>
                        @if (model.contractRejected && !UserData.isSalesManager(loggedUser)) {
                            <div class="signup-body-status-item-name failed">
                                Customer Agreement was declined. <a class="action-link" (click)="resetContract()">Unlock</a>
                                the form to make changes to the contract.
                            </div>
                        }
                        @if (!model.contractRejected && !(model.data.contract && model.data.contract.signedContract && model.data.contract.signedContract.customerSigned) && model.data.venue.salesRep) {
                            <div
                                class="signup-body-status-item-name">
                                Sign Customer Agreement (<a class="action-link" (click)="signInPerson()">Sign in person</a>
                                or <a class="action-link" (click)="sendSignUpUrl()">email
                                contract</a>)
                            </div>
                        }
                        @if (!model.contractRejected && !(model.data.contract && model.data.contract.signedContract && model.data.contract.signedContract.customerSigned) && !model.data.venue.salesRep) {
                            <div
                                class="signup-body-status-item-name">
                                Sign Customer Agreement
                            </div>
                        }
                        @if (!model.contractRejected && (model.data.contract && model.data.contract.signedContract && model.data.contract.signedContract.customerSigned)) {
                            <div
                                class="signup-body-status-item-name">
                                Sign Customer Agreement
                            </div>
                        }
                    </div>
                    <div class="signup-body-status-item">
                        <div class="signup-body-status-item-tick"
                             [ngClass]="{'complete': (model.data.billingAccount && model.data.billingAccount.paymentBankAccount)}">
                        </div>
                        <div class="signup-body-status-item-name">
                            Provide Direct Debit details
                        </div>
                    </div>
                    @if (customContract) {
                        <div class="signup-body-status-item">
                            <div class="signup-body-status-item-tick"
                                 [ngClass]="{'complete': (model.data.contract && model.data.contract.signedContract && model.data.contract.signedContract.directorSigned)}">
                            </div>
                            <div class="signup-body-status-item-name">
                                Chewzie Sales Director Approval
                            </div>
                        </div>
                    }
                    @if (model.signUpComplete && !tyro && (model.appPaymentAccountVerified || !model.data.hasSales)) {
                        <div class="signup-body-status-item">
                            <div class="signup-body-status-item-tick"
                                 [ngClass]="{'complete': model.appPaymentAccountVerified}">
                            </div>
                            @if (!model.appPaymentAccountVerified) {
                                <div class="signup-body-status-item-name">
                                    App Payment Account (Stripe Details) (<a class="action-link"
                                                                             (click)="openAppPaymentAccountSetup()">Setup
                                    Stripe In Person</a>) or (<a class="action-link"
                                                                 (click)="getSetupAppPaymentAccountUrl()">Copy
                                    Link</a>)
                                </div>
                            }
                            @if (model.appPaymentAccountVerified) {
                                <div class="signup-body-status-item-name">
                                    App Payment Account (Stripe Details)
                                </div>
                            }
                        </div>
                    }
                    @if (model.data.buildTask) {
                        <div class="signup-body-status-item">
                            <div class="signup-body-status-item-tick"
                                 [ngClass]="{'complete': (!model.data.buildTask.pendingSalesHandover)}">
                            </div>
                            <div class="signup-body-status-item-name">
                                Complete Sale Handover
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
        @if (!model.draft && !model.signUpComplete && !UserData.isSalesManager(loggedUser)) {
            <div class="signup-footer">
                @if (model.data.venue.salesRep) {
                    <div class="signup-footer-message">
                        Editing venue details is locked. <a class="action-link" (click)="resetContract()">Unlock</a> the
                        sign up form to edit venue details.
                    </div>
                }
                @if (!model.data.venue.salesRep) {
                    <div class="signup-footer-warning">
                        Unable to complete sign up. Sales Rep is required.
                    </div>
                }
            </div>
        }
    }

    @if (this.model.data.venue.deploymentStatus === CustomerInstanceVenueData.DEPLOYMENT_STATUS_CHURNED) {
        <div class="signup-body">
            <div class="signup-body-message">
                Venue is <b>Churned</b>.
            </div>

        </div>
    }
</div>
